import Spinners from 'components/Common/Spinner';
import TableContainer from 'components/Common/TableContainer';
import moment from 'moment';
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Input } from 'reactstrap';
import { getAllGatePassRequest, updateGatePassRequest } from 'store/actions';

const GatePassCheckInOut = () => {
  const dispatch = useDispatch();

  const { gatePassRequestList, loading, message, error, isCreated } = useSelector(state => state.GatePassReducer);



  const calculateCheckInHours = (data) => {
    const startTime = new Date(data.requested_checkin);
    const endTime = new Date(data.actual_checkin);

    if (isNaN(startTime) || isNaN(endTime) && data.status === "Checked-Out") {
      return (
        <Button
          color='primary'
          onClick={() => checkInGatePassStatus(data)}
        >
          Check IN
        </Button>
      );
    }

    if (data.status !== "Checked-In / Completed") return null
    const diffMs = endTime - startTime;
    const diffHours = diffMs / (1000 * 60 * 60);
    const absHours = Math.abs(diffHours);

    const days = Math.floor(absHours / 24);
    const hours = Math.floor(absHours % 24);

    if (diffHours > 0) {
      // Late
      if (days > 0) return <div className='text-danger'>{`${days} day${days > 1 ? 's' : ''} and ${hours} hour${hours !== 1 ? 's' : ''} late`}</div>;
      return <div className='text-danger'>{`${hours} hour${hours !== 1 ? 's' : ''} late`}</div>;
    } else {
      // Early
      if (days > 0) return <div className='text-success'>{`${days} day${days > 1 ? 's' : ''} and ${hours} hour${hours !== 1 ? 's' : ''} early`}</div>;
      return <div className='text-success'>{`${hours} hour${hours !== 1 ? 's' : ''} early`}</div>;
    }

  };



  const calculateCheckOutHours = (data) => {
    const startTime = new Date(data.requested_checkout);
    const endTime = new Date(data.actual_checkout);

    if (data.status !== "Pending") {
      if (isNaN(startTime) || isNaN(endTime)) {
        return (
          <Button
            color='primary'
            onClick={() => checkOutGatePassStatus(data)}
          >
            Check Out
          </Button>
        );
      }

      const diffMs = endTime - startTime;
      const diffHours = diffMs / (1000 * 60 * 60);
      const absHours = Math.abs(diffHours);

      const days = Math.floor(absHours / 24);
      const hours = Math.floor(absHours % 24);

      if (diffHours > 0) {
        // Late
        if (days > 0) return <div className='text-danger'>{`${days} day${days > 1 ? 's' : ''} and ${hours} hour${hours !== 1 ? 's' : ''} late`}</div>;
        return <div className='text-danger'>{`${hours} hour${hours !== 1 ? 's' : ''} late`}</div>;
      } else {
        // Early
        if (days > 0) return <div className='text-danger'>{`${days} day${days > 1 ? 's' : ''} and ${hours} hour${hours !== 1 ? 's' : ''} early`}</div>;
        return <div className='text-danger'>{`${hours} hour${hours !== 1 ? 's' : ''} early`}</div>;
      }
    }


  };



  const checkInGatePassStatus = (data) => {
    dispatch(updateGatePassRequest({
      "id": data.id,
      "actual_checkin": new Date(),
      "status": "Checked-In / Completed",
      "operation": "checkin"
    }))
  }

  const checkOutGatePassStatus = (data) => {
    dispatch(updateGatePassRequest({
      "id": data.id,
      "actual_checkout": new Date(),
      "status": "Checked-Out",
      "operation": "chekout"
    }))
  }

  const columns = useMemo(
    () => [
      {
        Header: () => <div style={{ color: "#111" }}>#</div>,
        accessor: "id",
        filterable: true,
        Cell: ({ row, rows }) => {
          const rowIndex = rows.indexOf(row) + 1
          return rowIndex
        },
      },
      // {
      //   Header: () => <div style={{ color: "#111" }}>Request</div>,
      //   accessor: "created_date",
      //   filterable: true,
      //   Cell: ({ value }) => moment(value).format("DD/MM/YYYY") || "",
      // },
      {
        Header: () => <div style={{ color: "#111" }}>Staff</div>,
        accessor: "staff_name",
        filterable: true,
        Cell: ({ value }) => value || "",
      },
      {
        Header: () => <div style={{ color: "#111" }}>Reason</div>,
        accessor: "reason",
        filterable: true,
        Cell: ({ value }) => value || "",
      },
      {
        Header: () => <div style={{ color: "#111" }}>CheckOut</div>,
        accessor: "requested_checkout",
        filterable: true,
        Cell: ({ value, row }) => {
          return (
            <div className='d-flex flex-column align-items-center'>
              <div>{moment(value).format("DD/MM/YYYY")}</div>
              <div>{calculateCheckOutHours(row.original)}</div>
            </div>
          )
        },
      },
      {
        Header: () => <div style={{ color: "#111" }}>CheckIn</div>,
        accessor: "requested_checkin",
        filterable: true,
        Cell: ({ value, row }) => {

          return (
            <div className='d-flex flex-column align-items-center'>
              <div>{moment(value).format("DD/MM/YYYY")}</div>
              <div>{calculateCheckInHours(row.original)}</div>
            </div>
          )
        },
      },
      // {
      //   Header: () => <div style={{ color: "#111" }}>hours</div>,
      //   accessor: "xyz",
      //   filterable: true,
      //   Cell: ({ value, row }) => {
      //     const checkin = row.original.requested_checkin;
      //     const checkout = row.original.requested_checkout; // Replace with your actual accessor

      //     return calculateHours(checkout, checkin) || "";
      //   },
      // },
      {
        Header: () => <div style={{ color: "#111" }}>Status</div>,
        accessor: "status",
        filterable: true,
        Cell: ({ value, row }) => (
          value
        ),
      },


    ],
    [gatePassRequestList]
  );


  useEffect(() => {
    if (message) {
      toast.success(message)
    }
  }, [message])

  useEffect(() => {
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(getAllGatePassRequest())
  }, [])

  useEffect(() => {
    if (isCreated) dispatch(getAllGatePassRequest())
  }, [isCreated])

  return (
    <div className='page-content'>
      <div className='d-flex mb-3'>
        <h6 className='text-primary'>Gate Pass CheckIn & CheckOut</h6>
      </div>



      {loading ? (
        <Spinners />
      ) : (
        <TableContainer
          columns={columns}
          data={gatePassRequestList}
          isGlobalFilter={true}
          isAddOptions={false}
          // handleJobClicks={handleJobClicks}
          isJobListGlobalFilter={false}
          isPagination={true}
          iscustomPageSizeOptions={true}
          isShowingPageLength={true}
          customPageSize={100}
          tableClass="table-bordered align-middle nowrap mt-2"
          paginationDiv="col-sm-12 col-md-7"
          pagination="pagination justify-content-end pagination-rounded"
        />
      )}
    </div>
  )
}

export default GatePassCheckInOut